/*
 * @Author: your name
 * @Date: 2021-08-19 15:17:19
 * @LastEditTime: 2021-08-30 14:09:15
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \dc-hero-bump-website-front\src\router\index.js
 */

import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import gameNews from '@/views/gameNews'
import NewsList from '@/components/NewsList'
import NewsDetail from '@/components/NewsDetail'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/',
        name: 'home',
        component: Home
      },
      {
        path: '/gameNews',
        name: 'gameNews',
        component: gameNews,
        children: [
          {
            path: '/gameNews/',
            redirect: '/gameNews/newsList'
          },
          {
            path: '/gameNews/newsList',
            component: NewsList
          },
          {
            path: '/gameNews/newsDetail',
            component: NewsDetail
          }

        ]
      }
    ]
  })
